import http from 'utils/http';

import { SOURCE_CONFIG } from '@/pages/Agency/OnboardingForms/constants';

import { getOnboardingInsightsUrl } from './apiUrls';
import { OnboardingInsightsApiResponse, OnboardingInsightsViewModel, SourceBreakdownItem } from './types';

function transformSourceBreakdown(
  sourceBreakdown: OnboardingInsightsApiResponse['source_breakdown']
): SourceBreakdownItem[] {
  const items = (Object.entries(sourceBreakdown) as [string, number][]).map(([source, count]) => ({
    source,
    label: SOURCE_CONFIG[source]?.label ?? source,
    count,
    percentage: 0,
    color: SOURCE_CONFIG[source]?.chartColor ?? '#1E40AF'
  }));

  const total = items.reduce((sum, item) => sum + item.count, 0);

  return items.map((item) => ({
    ...item,
    percentage: total > 0 ? Math.round((item.count / total) * 100) : 0
  }));
}

export async function getOnboardingInsights(): Promise<OnboardingInsightsViewModel> {
  const response = (await http.get(getOnboardingInsightsUrl())) as OnboardingInsightsApiResponse;

  return {
    avg_business_setup_time: response.avg_business_setup_time,
    avg_agent_delivery_time: response.avg_agent_delivery_time,
    avg_go_live_time: response.avg_go_live_time,
    monthly_completed_trend: response.monthly_completed_trend,
    status_breakdown: response.status_breakdown,
    source_breakdown: transformSourceBreakdown(response.source_breakdown),
    ai_receptionist_reasons_breakdown: response.ai_receptionist_reasons_breakdown ?? []
  };
}
